var $ = require('jquery');
'use strict';

var PLUGIN_NAME = 'fulltextAutocomplete';

var	DEFAULTS = {
	querySelector: '#query'	,
	categorySelector: '#category',
	url: null
};

/**
 *
 * @param selector
 * @param options
 * @constructor
 */
var FulltextAutocomplete = function (selector, options) {
	this.$t = $(selector);
	this.options = $.extend(true, {}, DEFAULTS, options );
	this._defaults = DEFAULTS;
	this.initialise_();
};

/**
 *
 * @private
 */
FulltextAutocomplete.prototype.initialise_ = function() {

	if (!this.options.url || this.options.url == '') {
		return false;
	}

	this.$categoryInput = $(this.options.categorySelector, this.$t);
	this.$queryInput = $(this.options.querySelector, this.$t);

	this.keyUpTimer = null;
	this.$renderedResult = null;
	this.valBeforeKeyPress = '';
	this.selectedItem = -1;

	this.$queryInput.attr('autocomplete', 'off');

	this.hasCategorySelect = this.$categoryInput instanceof $;

	this.bindTextEntering_();

};

/**
 * bind keyup akce - psaní textu do query inputu
 * @private
 */
FulltextAutocomplete.prototype.bindTextEntering_ = function() {

	var self_ = this;

	this.$queryInput.on('keyup.fa_', function(e) {

		clearTimeout(self_.keyUpTimer);
		var val = $(e.currentTarget).val();

		if (val.length < 2) {
			self_.removeAutocompleteResult_();
			return false;
		}

		if (self_.valBeforeKeyPress == val) return false;

		self_.keyUpTimer = setTimeout(function() {
			self_.performSearch_(val);
		}, 400);

	});

};

/**
 * samotné vyhledání dotazu - AJAX
 * @param query
 * @private
 */
FulltextAutocomplete.prototype.performSearch_ = function(query) {
	var self_ =  this;
	this.$t.addClass('fa-loading');

	var searchData = { query: query };

	if (this.hasCategorySelect && this.$categoryInput.val() && this.$categoryInput.val() != '') {
		searchData.category =  this.$categoryInput.val()
	}

	$.ajax({
		url: this.options.url,
		data: searchData,
		method: 'GET',
		cache: false
	}).done(function(data) {
		if (data && data.length > 0) {
			self_.renderResults_(data);
		} else {
			self_.removeAutocompleteResult_();
		}
	});
};

FulltextAutocomplete.prototype.renderResults_ = function(data) {
	this.selectedItem = -1;
	this.removeAutocompleteResult_();

	this.$t.removeClass('fa-loading');
	this.$renderedResult = $(data).insertAfter(this.$queryInput);

	this.bindAutocompleteResultEvents_();
};


/**
 * removes rendered resuts, if any
 * @private
 */
FulltextAutocomplete.prototype.removeAutocompleteResult_ = function() {
	if (this.$renderedResult &&  this.$renderedResult instanceof $) {
		this.$renderedResult.remove();
	}
	this.selectedItem = -1;
};

FulltextAutocomplete.prototype.bindAutocompleteResultEvents_ = function() {

	var self_ = this;
	this.$queryInput.off('keydown.ta_').on('keydown.ta_', function(e) {

		self_.valBeforeKeyPress = self_.$queryInput.val();

		if ((self_.$renderedResult instanceof $)) {
			var liCnt = $('li', self_.$renderedResult).size();
			// down
			if (e.keyCode == 40) {
				e.preventDefault();
				if (self_.selectedItem < liCnt-1) {
					self_.selectedItem++;
				}
			}

			// up
			if (e.keyCode == 38) {
				e.preventDefault();
				if (self_.selectedItem > 0) {
					self_.selectedItem--;
				}
			}

			//enter
			if (e.keyCode == 13) {

				if (self_.selectedItem > -1 && self_.selectedItem < $('li', self_.$renderedResult).size()) {
					e.preventDefault();
					// TODO action
					self_.performSelectAction_($('li:eq('+self_.selectedItem+') > a', self_.$renderedResult));
				} else {
					self_.removeAutocompleteResult_();
				}
			}

			//escape
			if (e.keyCode == 27) {
				e.preventDefault();
				self_.$queryInput.val('');
				self_.removeAutocompleteResult_();
			}



			$('li', self_.$renderedResult).removeClass('active');
			if (self_.selectedItem > -1) {
				$('li:eq('+self_.selectedItem+')', self_.$renderedResult).addClass('active');
			}
		}
	});

	$(this.$renderedResult).on('mouseover', 'li', function(e) {
		$('li', self_.$renderedResult).removeClass('active');
		$(e.currentTarget).addClass('active');
		self_.selectedItem = $('li', self_.$renderedResult).index(e.currentTarget);
	});

	$(this.$renderedResult).on('click', 'li > a', function(e) {
		e.preventDefault();
		self_.performSelectAction_($(e.currentTarget));
	});

	/*this.$queryInput.off('blur.ta_').on('blur.ta_', function(e) {
		e.preventDefault();

		setTimeout(function() {
			self_.removeAutocompleteResult_();
		}, 100);

	});*/
};



FulltextAutocomplete.prototype.performSelectAction_ = function($element) {
	if (!($element instanceof $)) {
		return false;
	}

	if ($element.attr('href') && $element.attr('href') !== '') {
		window.location.href = $element.attr('href');
	}
};
/**
 * decide, which methods will be "public"
 */
var API = {
};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 * 		if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
	var args = arguments;

	return this.each(function () {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new FulltextAutocomplete(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};


// WEBPACK FOOTER //
// ./node_modules/fg-frontend/edeeshop/jquery.fulltextAutocomplete.js